import { makeStyles } from "tss-react/mui"

export const useStyles = makeStyles()(({ shadows, spacing }) => ({
  container: {
    padding: spacing(1, 2),
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: spacing(2),
    justifyContent: "space-between",
    boxShadow: shadows[2]
  },
  blockContainer: {
    gap: spacing(1),
    flexDirection: "row"
  }
}))
